import React from 'react';
import styled from 'styled-components';
import { X, ShoppingCart } from 'lucide-react';
import Cart from './Cart';
import { useNavigate } from 'react-router-dom';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  z-index: 1000;
  animation: fadeIn 0.3s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background-color: white;
  width: 400px;
  height: 100%;
  padding: 20px;
  overflow-y: auto;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease-out;

  @keyframes slideIn {
    from { transform: translateX(100%); }
    to { transform: translateX(0); }
  }
`;

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const ModalTitle = styled.h2`
  font-size: 24px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 10px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #7f8c8d;
  transition: color 0.2s;

  &:hover {
    color: #34495e;
  }
`;

const CartModal = ({ isOpen, onClose, showToast }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleProceedToCheckout = () => {
    onClose();
    navigate('/checkout');
  };
  const handleContinueShopping = () => {
    onClose();
    navigate('/');  // Redirect to shopping page
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>
            <ShoppingCart size={24} />
            Your Cart
          </ModalTitle>
          <CloseButton onClick={onClose}>
            <X size={24} />
          </CloseButton>
        </ModalHeader>
        <Cart showToast={showToast}
         onProceedToCheckout={handleProceedToCheckout}
          showCheckoutButton={true}
          onContinueShopping={handleContinueShopping}
           />
      </ModalContent>
    </ModalOverlay>
  );
};

export default CartModal;

